import { render, staticRenderFns } from "./DisplayTableRow.vue?vue&type=template&id=022abc35&"
import script from "./DisplayTableRow.vue?vue&type=script&lang=js&"
export * from "./DisplayTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports